<template>

<div>

    <h1>Create new customer</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createCustomer">

        <CustomerFields></CustomerFields>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create customer</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import CustomerFields from '@/components/CustomerFields.vue'
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      customer: {
        country_id:220
      },
      countries: null,
      referrers: null,
      errors: null
    }
  },
  components: {
    CustomerFields,
    Errors
  },
  methods: {
    createCustomer () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'customers/create/new-customer', {
        method: 'POST',
        body: JSON.stringify(this.customer),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          if(this.$route.path == '/bookings/create') {
            this.$parent.creatingCustomer = false
            this.$parent.booking.customer = response.data
          } else {
            this.$router.push({ name: 'customer-edit', params: { id: response.data.id }})
          }
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  },
  mounted(){
    this.customer.postcode = this.$route.query.postcode
  }
}
</script>
